import React from "react";
import { useHistory } from "react-router-dom";
import { Button, NonIdealState } from "@blueprintjs/core";
import { faGithub, faGitlab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useAuth } from "@api";
import { UserContext } from "@providers";

export const LoginPrompt: React.FC<{ returnPath: string }> = ({
  returnPath,
}) => {
  const history = useHistory();
  return (
    <NonIdealState
      title="✨ Welcome to Semgrep! ✨"
      description={
        <>
          Sign in with GitHub, GitLab, or SSO. <br /> It's free.
        </>
      }
      action={
        <Button
          onClick={() => history.push(`/login?return_path=${returnPath}`)}
          intent="primary"
          large
        >
          Continue
        </Button>
      }
    />
  );
};

export const InstallPrompt: React.FC<{}> = () => {
  const { user } = React.useContext(UserContext);
  const { install } = useAuth();
  return (
    <div>
      {user && user.auth_provider_type === "gitlab" ? (
        <NonIdealState
          description="It looks like you don't have an organization associated with your user. Add a GitLab group to get started!"
          action={
            <Button
              onClick={async () => {
                await install("gitlab");
              }}
              intent="primary"
              large
            >
              Add GitLab group <FontAwesomeIcon icon={faGitlab} />
            </Button>
          }
        />
      ) : (
        <NonIdealState
          title="✨ Almost good to go! ✨"
          description="It looks like you don't have an organization associated with your user. Add the Semgrep GitHub app to get started!"
          action={
            <Button
              onClick={async () => {
                await install("github");
              }}
              intent="primary"
              large
            >
              Add GitHub organization <FontAwesomeIcon icon={faGithub} />
            </Button>
          }
        />
      )}
    </div>
  );
};
